import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutAnimationService {
  isEnterAppAnimationActive$: BehaviorSubject<boolean>;
  isEnterAppAnimationCompleted$: BehaviorSubject<boolean>;

  /**
   * init
   *
   */
  init(): void {
    this.isEnterAppAnimationActive$ = new BehaviorSubject<boolean>(false);
    this.isEnterAppAnimationCompleted$ = new BehaviorSubject<boolean>(false);
  }

  /**
   * runEnterAppAnimation
   *
   */
  runEnterAppAnimation(): void {
    this.isEnterAppAnimationActive$.next(true);
  }

  /**
   * completeEnterAppAnimation
   *
   */
  completeEnterAppAnimation(): void {
    this.isEnterAppAnimationCompleted$.next(true);
  }
}
